export const PERMISSION_LABELS = {
  admin: "Admin",
  cliente: "Cliente",
  frs: "FRS",
  frp: "FRP",
  lider: "Líder",
  liderl: "Evaluado",
  ghumana: "Gestión humana",
  cultura: "Cultura",
  free: "Clima",
};

export const PERMISSION_GROUPS = {
  userTypes: [
    {
      key: "cliente",
      label: "Cliente",
      description: "Accede solo a los módulos que se le asignen",
    },
    {
      key: "admin",
      label: "Admin",
      description: "Administra la plataforma; no lleva permisos por módulo",
    },
  ],
  modules: [
    {
      title: "Factores de riesgo",
      description: "FRS y FRP",
      requiresCliente: true,
      items: [
        { key: "frs", label: "Factores" },
        { key: "frp", label: "Factores Nuevo" },
      ],
    },
    {
      title: "Liderazgo",
      description: "Líderes PHD",
      requiresCliente: true,
      items: [
        { key: "lider", label: "Líder Admin" },
        { key: "liderl", label: "Evaluado" },
        { key: "ghumana", label: "G. Humana" },
      ],
    },
    {
      title: "Cultura",
      description: "Diagnóstico de cultura",
      requiresCliente: true,
      items: [{ key: "cultura", label: "G. Cultura" }],
    },
    {
      title: "Clima",
      description: "CL7",
      requiresCliente: false,
      items: [{ key: "free", label: "G. Cl7" }],
    },
  ],
};

export const NO_COMPANY_LABEL = "Sin compañía asignada";

export const normalizeSearch = (text) => String(text || "").trim();

export const buildUsersParams = ({ startRow, limit, search, claims }) => {
  const params = { startRow, limit };
  const normalized = normalizeSearch(search);
  if (normalized) params.search = normalized;
  if (claims && claims.length) params.claims = claims.join(",");
  return params;
};

export const parseUsersBlock = (data) => {
  if (
    !data ||
    !Array.isArray(data.rows) ||
    typeof data.total !== "number"
  ) {
    throw new Error("Invalid users block response");
  }
  return { rows: data.rows, total: data.total };
};

export const escapeHtml = (text) =>
  String(text === null || text === undefined ? "" : text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const getInitials = (user) => {
  const source = String((user && (user.displayName || user.email)) || "").trim();
  if (!source) return "?";
  const words = source.split(/\s+/);
  const first = words[0].charAt(0);
  const second = words.length > 1 ? words[1].charAt(0) : "";
  return (first + second).toUpperCase();
};

export const getCompanyName = (user) =>
  (user && user.currentCompany && user.currentCompany.nombre) ||
  NO_COMPANY_LABEL;

export const getPermissionEntries = (claims) => {
  const source = claims || {};
  return Object.keys(PERMISSION_LABELS)
    .filter((key) => source[key] === true)
    .map((key) => ({ key, label: PERMISSION_LABELS[key] }));
};

export const getPermissionLabels = (claims) =>
  getPermissionEntries(claims).map((entry) => entry.label);

export const renderSkeleton = (width) =>
  `<div class="user-skeleton-bar" style="width: ${width || "60%"}"></div>`;

export const renderUserCell = (params) => {
  if (!params.data) return renderSkeleton("70%");
  const user = params.data;
  return `
    <div class="user-cell">
      <span class="us-avatar">${escapeHtml(getInitials(user))}</span>
      <div class="user-cell-text">
        <div class="user-cell-name">${escapeHtml(user.displayName)}</div>
        <div class="user-cell-email">${escapeHtml(user.email)}</div>
      </div>
    </div>
  `;
};

export const renderCompanyCell = (params) => {
  if (!params.data) return renderSkeleton("55%");
  return `<span class="user-company">${escapeHtml(
    getCompanyName(params.data),
  )}</span>`;
};

export const renderPermissionsCell = (params) => {
  if (!params.data) return renderSkeleton("65%");
  const entries = getPermissionEntries(params.data.claims);
  if (!entries.length) return "";
  const visible = entries
    .slice(0, 3)
    .map(
      (entry) =>
        `<span class="us-tag us-tag--${entry.key}">${escapeHtml(
          entry.label,
        )}</span>`,
    )
    .join("");
  const extra =
    entries.length > 3
      ? `<span class="us-tag us-tag--more">+${entries.length - 3}</span>`
      : "";
  const title = entries.map((entry) => entry.label).join(", ");
  return `<div class="user-tags" title="${escapeHtml(
    title,
  )}">${visible}${extra}</div>`;
};



// WEBPACK FOOTER //
// ./src/components/users/helpers.js